import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class TrainingService extends BaseService {
	constructor() {
		super('/Training');
	}


	public getAllByFilter(filter: TrainingFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getTrainingForPersonByFilter(filter: TrainingFilter) {
		return super.getAllByFilterBase(filter, "training-for-person");
	}
}

export class TrainingFilter extends BaseFilter {
	constructor(idPerson?: number | null) {
		super();
		this._idPerson = idPerson;
	}

	private _idPerson?: number | null;

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._idPerson != null ? { IdPerson: this._idPerson } : {})
		);
		return data;
	};
}